<div class="wrapper">
    <app-user-avatar [firstname]="order?.customer?.firstname"
        [lastname]="order?.customer?.surname"></app-user-avatar>
    <div class="header">{{order?.customer?.firstname}} {{order?.customer?.surname}} - Lorem ipsum
    </div>
    <div class="content">
        <div class="text">
            <div class="line-wrapper"><span class="title">Line
                    number: </span><span>{{order.lineId}}</span></div>
        </div>
    </div>
    <div class="footer">

        <div class="text">
            <div class="status-wrapper">In <span class="status">{{order?.status?.name}}</span></div>
        </div>
        <div class="state-icon">
            <svg xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 0 24 24"
                width="24px"
                fill="#000000">
                <path d="M0 0h24v24H0z"
                    fill="none" />
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
            </svg>
        </div>
    </div>
</div>